import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Inject } from '@angular/core';
import * as dropin from 'braintree-web-drop-in';
import { DOCUMENT } from '@angular/common';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ConfigService } from "../../Services/ConfigService";
import { PaymentService } from '../../Services/Custom/ServicePayment';
import { PaymentSystemEnum } from '../../Models/Interfaces/PaymentSystemEnum';


@Component({
	selector: 'MakePaymentPartial',
	templateUrl: 'MakePayment.html',

})
export class MakePaymentPartialComponent implements OnInit, OnDestroy {

	protected obsToCloseSubject = new Subject();
	ngOnDestroy() {
		this.obsToCloseSubject.next(null);
		this.obsToCloseSubject.complete();
		var globalWindow: any = window;
		globalWindow.paymentCallback = null;
		globalWindow.paymentCallbackContext = null;
	}

	disabled: boolean = false;
	paymentSystem: TooBig4Car.Logic.PublicPaymentSystemInfoVM = {
		PaymentSystem: PaymentSystemEnum.None
	};
	ngOnInit(): void {

	}

	constructor(
		@Inject(DOCUMENT) private doc: any,
		public configData: ConfigService,
		private myPaymentService: PaymentService,
	) {
		var globalWindow: any = window;
		globalWindow.paymentCallback = this.runCardXPayment;
		globalWindow.paymentCallbackContext = this;
	}

	@Input()
	set payInfo(val: TooBig4Car.Logic.PublicPaymentInfoVM) {
		this.myItem = val;
		if (!this.configData.IsEmptyGuid(this.myItem.PickupDeliveryID)) {
			this.loadItem();
		}
		this.loadCardXScript();
	}
	myItem = {} as TooBig4Car.Logic.PublicPaymentInfoVM;

	@Input()
	customerID: System.Guid = '';


	@Output()
	success = new EventEmitter<TooBig4Car.Logic.PublicPaymentInfoVM>();

	@Output()
	error = new EventEmitter();

	@Output()
	progress = new EventEmitter<boolean>();

	btInstance: any = null;

	get showCardX(): boolean {
		return PaymentSystemEnum.CardX == this.paymentSystem?.PaymentSystem;
	}

	get showBrainTree(): boolean {
		return PaymentSystemEnum.Braintree == this.paymentSystem?.PaymentSystem
			;
	}

	loadCardXScript() {
		if (PaymentSystemEnum.CardX == this.paymentSystem.PaymentSystem) {

			let s = this.doc.getElementById('cardx_lightbox_script');
			if (!s) {
				s = this.doc.createElement('script');
				s.type = 'text/javascript';
				s.id = "cardx_lightbox_script";
				s.setAttribute("data-button", "#pay_with_cardx");
				s.setAttribute("data-callback", "paymentCallback");
				s.setAttribute("data-mode", "payment");
				const head = this.doc.getElementsByTagName('head')[0];
				head.appendChild(s);
			}
			s.setAttribute("src", "https://" + (this.paymentSystem.IsSandbox ? 'test.' : '') + "lightbox.cardx.com/v1/lightbox.min.js");
			s.setAttribute("data-account", this.paymentSystem.Account);
			s.setAttribute("data-amount", this.myItem.PaymentAmount);
		}
	}
	loadItem() {
		var thisholder = this;
		var obs: Observable<TooBig4Car.Logic.PublicPaymentSystemInfoVM>;
		if (this.configData.IsEmptyGuid(this.customerID)) {

			obs = this.myPaymentService.getAnonToken();
		} else {
			obs = this.myPaymentService.getCustomerToken(this.customerID);

		}
		obs.pipe(takeUntil(this.obsToCloseSubject))
			.subscribe(pmtObj => {
				this.paymentSystem = pmtObj;
				this.myItem.PaymentSystem = this.paymentSystem.PaymentSystem;
				switch (this.paymentSystem.PaymentSystem) {
					case PaymentSystemEnum.CardX:
						this.loadCardXScript();
						break;
					case PaymentSystemEnum.Braintree:
						if (!this.btInstance) {
							dropin.create({
								authorization: this.paymentSystem.Token,
								container: '#dropin-container',
							}, function (createErr: any, dropinInstance: any) {
								if (createErr) {
									var errStr = 'Failed: ' + createErr.message + '. Please try again.';
									thisholder.error.emit(errStr);
								} else if (dropinInstance) {
									thisholder.btInstance = dropinInstance;

									if (dropinInstance.isPaymentMethodRequestable()) {
										// This will be true if you generated the client token
										// with a customer ID and there is a saved payment method
										// available to tokenize with that customer.
										thisholder.disabled = false;
									}

									dropinInstance.on('paymentMethodRequestable', function (event: any) {
										console.log(event.type); // The type of Payment Method, e.g 'CreditCard', 'PayPalAccount'.
										console.log(event.paymentMethodIsSelected); // True if a customer has selected a payment method when paymentMethodRequestable fires.
										if (event.paymentMethodIsSelected) {
											thisholder.disabled = false;
										}
									});

									dropinInstance.on('noPaymentMethodRequestable', function () {
										thisholder.disabled = true;
									});
								}
							});
						}
						break;
					default:
						this.disabled = true;
						break;
				}

			});
	}

	runCardXPayment(err: any, message: any) {
		var globalWindow: any = window;
		var thisHolder = globalWindow.paymentCallbackContext;
		if (!thisHolder.disabled) {
			if (err) {
				thisHolder.error.emit(err);
			} else {

				if ("success" == (message?.pi_response_status ?? "")) {
					thisHolder.myItem.Memo = 'CardX Order ID: ' + (message?.pt_order_id || '');
					thisHolder.progress.emit(true);
					thisHolder.myPaymentService.runPublicPayment('cardx', thisHolder.myItem)

						.subscribe(() => {
							thisHolder.progress.emit(false);
							thisHolder.myItem.PaymentAmount = 0;
							thisHolder.myItem.TipAmount = 0;
							thisHolder.success.emit(thisHolder.myItem);

						},
							(error: any) => {
								thisHolder.error.emit(error);
							});
				} else if ((message?.response ?? "").indexOf('cancelled') >= 0) { 
				} else {
					thisHolder.error.emit("Payment Failed");
				}
			}
		}

	}

	runPayment() {
		var thisHolder = this;
		if (!this.disabled) {

			if (this.btInstance) {
				this.btInstance.requestPaymentMethod(function (err: any, payload: any) {
					if (payload.nonce) {
						thisHolder.progress.emit(true);
						thisHolder.myPaymentService.runPublicPayment(payload.nonce, thisHolder.myItem)

							.subscribe(pmt => {
								thisHolder.progress.emit(false);
								thisHolder.myItem.PaymentAmount = 0;
								thisHolder.myItem.TipAmount = 0;
								thisHolder.success.emit(thisHolder.myItem);

							},
								(error: any) => {
									thisHolder.error.emit(error);
								});
					}
				});
			}

		}
	}
}
